import { render, staticRenderFns } from "./AppEdit.vue?vue&type=template&id=5e6be82b&"
import script from "./AppEdit.vue?vue&type=script&lang=js&"
export * from "./AppEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports